import { useCallback, useState } from "react";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { EventEditionDetails, IProduct } from "../../../../common/types";
import { SNACKBAR_VARIANTS } from "../../../../common/constants";
import { useCmsImages } from "../useCmsImages/useCmsImages";

export const useBadgeLogosRetrieval = () => {
  const { preloadBadgeImagesForEvents } = useCmsImages();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { t } = useTranslation("common");

  const [isBadgeLogosRetrievalInProgress, setIsBadgeLogosRetrievalInProgress] = useState(false);

  const runBadgeLogosRetrieval = useCallback(
    async (products: IProduct[], eventEdition: EventEditionDetails | null | undefined): Promise<boolean> => {
      if (!eventEdition) {
        return true;
      }

      if (isBadgeLogosRetrievalInProgress) {
        return false;
      }

      setIsBadgeLogosRetrievalInProgress(true);
      const loadingSnackbarKey = enqueueSnackbar(<b>{t("common.badgeLogosRetrievalInProgress")}</b>, {
        ...SNACKBAR_VARIANTS.warning,
        persist: true
      });

      try {
        await preloadBadgeImagesForEvents(products, eventEdition);
        enqueueSnackbar(<b>{t("common.badgeLogosRetrievalCompleted")}</b>, SNACKBAR_VARIANTS.success);

        return true;
      } catch (e) {
        enqueueSnackbar(<b>{t("common.badgeLogosRetrievalFailedTryLaterInGlobalSettings")}</b>, SNACKBAR_VARIANTS.error);
        return false;
      } finally {
        closeSnackbar(loadingSnackbarKey);
        setIsBadgeLogosRetrievalInProgress(false);
      }
    },
    [closeSnackbar, enqueueSnackbar, preloadBadgeImagesForEvents, isBadgeLogosRetrievalInProgress, t]
  );

  return {
    runBadgeLogosRetrieval,
    isBadgeLogosRetrievalInProgress
  };
};
